import type { Command } from './types'

export function triggerCommandEvent(input: Command.CommandType) {
  document.dispatchEvent(new CustomEvent('ws:command', { detail: input }))
}

export function registerCommandEventListener(
  callback: (event: { detail: Command.CommandType }) => void,
) {
  document.addEventListener('ws:command' as any, callback)
}

export function unregisterCommandEventListener(callback: (arg: any) => void) {
  document.removeEventListener('ws:command' as any, callback)
}
